<template>
	<div
		:class="[
			gridCols,
			'px-2 py-8 space-y-6 sm:space-y-12'
		]"
	>
		<div
			v-for="(tier) in billables"
			:key="tier.id"
		>
			<PricingCard
				:tier="tier"
				:selected-tier-index="selectedTierIndex"
				:button-text="$t('get-fiber.choose-plan.pricing-cards.view-details')"
				@set-tier="setTier"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { MappedPackage } from '@/types/components/signup'

const props = defineProps({
	selectedTierIndex: {
		type: Number,
		default: 0
	},
	billables: {
		type: Array as PropType<MappedPackage[]>,
		required: true
	}
})

const {
	selectedTierIndex,
	billables
} = toRefs(props)

const emit = defineEmits([ 'setTier' ])
const setTier = (tier: number) => {
	emit('setTier', tier)
}

const gridCols = computed(() => {
	return billables.value?.length % 3 === 0 || billables.value?.length > 4 ? 'md:flex md:flex-wrap md:gap-x-16 md:gap-y-6 md:justify-center md:space-y-0' : 'md:grid md:place-items-end md:space-y-0 md:py-0 md:grid-cols-2'
})
</script>
